//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AddressEdit from "@/0/components/comForm/AddressEdit.vue";
export default {
  components: { "address-edit": AddressEdit },
  props: ["ConfigUrl"],
  data() {
    return {
      Choice: 0,
      information: {
        userName: "",
        telNumber: "",
        totalAddress: "", //省市区
        province: "", //省
        City: "", //市
        District: "", //区
        DetailedAddress: "",
        default: false,
        OpenId: "",
        type: 0
      },
      AddressList: []
    };
  },
  async created() {},
  async mounted() {
    await this.GetAddressList();
  },
  methods: {
    ReturnData(RowItem) {
      this.$emit("StepClose", RowItem);
    },
    async GetAddressList() {
      this.$msg.showLoading();
      let { data: result } = await this.$http({
        method: "post",
        url: this.ConfigUrl.GetIndexPaged,
        data: { PageIndex: 1, PageSize: 1000 }
      });
      this.$msg.hideLoading();
      console.log(result, "地址列表");
      this.AddressList = result.data.Rows;
    },
    GoAdd() {
      this.information = {
        userName: "",
        telNumber: "",
        totalAddress: "", //省市区
        province: "", //省
        City: "", //市
        District: "", //区
        DetailedAddress: "",
        default: false,
        OpenId: "",
        type: 0
      };
      this.Choice = 1;
    },
    GoEdit(RowItem) {
      console.log(RowItem);
      // information: {
      //   userName: "",
      //   telNumber: "",
      //   totalAddress: "", //省市区
      //   province: "", //省
      //   City: "", //市
      //   District: "", //区
      //   DetailedAddress: "",
      //   default: false,
      //   OpenId:'',
      //   type: 0
      // },
      var information = this.information;
      information.userName = RowItem.Contact;
      information.telNumber = RowItem.Mobile;
      information.DetailedAddress = RowItem.Address;
      information.totalAddress =
        RowItem.Province + RowItem.City + RowItem.District;
      information.province = RowItem.Province;
      information.City = RowItem.City;
      information.District = RowItem.District;
      information.type = 1;
      information.OpenId = RowItem.OpenId;
      this.information = information;
      this.Choice = 1;
    },
    ChoiceClose() {
      this.Choice = 0;
    }
  }
};
